import Model from 'flarum/common/Model';
/**
 * A support category (e.g. "Billing", "Appeals"). `isAppeal` categories are
 * the only ones a suspended/banned user may file under.
 */
export default class SupportCategory extends Model {
  name = (() => Model.attribute('name'))();
  slug = (() => Model.attribute('slug'))();
  description = (() => Model.attribute('description'))();
  color = (() => Model.attribute('color'))();
  icon = (() => Model.attribute('icon'))();
  position = (() => Model.attribute('position'))();
  isAppeal = (() => Model.attribute('isAppeal'))();
  ticketType = (() => Model.attribute('ticketType'))();
  allowedGroupIds = (() => Model.attribute('allowedGroupIds'))();
  canCreate = (() => Model.attribute('canCreate'))();
  allowedDecisions = (() => Model.attribute('allowedDecisions'))();
  ticketCount = (() => Model.attribute('ticketCount'))();
  getTicketTypeId() {
    return this.ticketType() || 'standard';
  }

  // The staff member new tickets here are assigned to, and the only person
  // notified about them. Null means no auto-assign: all staff are notified.
  // Serialized to staff only, so it reads as null for everyone else.
  defaultAssignee = (() => Model.hasOne('defaultAssignee'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-support', 'common/models/SupportCategory', SupportCategory);